export default __webpack_public_path__ + "static/media/twitter-logo.4844b78f.svg";